/* Keeps the "Dye to order" line-item property true for the WHOLE cart.
 *
 * WHOLE-LINE RULE (docs/sales-brief.html): if the total quantity of a variant in the cart is more than
 * the shelf holds (or the shelf is empty), EVERY line of that variant is dye to order, in full. 8 on
 * the shelf and 10 wanted = all ten dyed, the 8 stay for others. Otherwise none is. The property is
 * only ever the key "Dye to order" with the value the product page writes ("DYE TO ORDER · <local>"):
 * a Shopify Flow rule matches the key, and ops/dye_to_order_restock.py credits the full line.
 *
 * Stock and eligibility come from snippets/dto-state.liquid via the <script data-dto-lines> node; the
 * lines themselves come from /cart.js, so this works on what Shopify holds now. Loaded on every page by
 * layout/theme.liquid (a script tag inside the drawer's innerHTML would not run); it acts when the JSON
 * node is present and again whenever a new one appears (the drawer re-rendered after an add).
 *
 * It must never stand between a shopper and checkout: the checkout hold is capped at 2 seconds and any
 * failure lets the click through.
 */
(function () {
  if (window.__dtoSync) return;
  window.__dtoSync = true;
  var KEY = 'Dye to order', CAP_MS = 2000;
  var running = null, bypass = false;

  function cfg() {
    var el = document.querySelector('script[data-dto-lines]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function getJson(url) { return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }

  // The next line whose property is wrong, or null.
  function nextChange(cart, c) {
    var total = {}, i, it;
    for (i = 0; i < cart.items.length; i++) { it = cart.items[i]; total[it.variant_id] = (total[it.variant_id] || 0) + it.quantity; }
    for (i = 0; i < cart.items.length; i++) {
      it = cart.items[i];
      var v = c.v[it.variant_id];
      if (!v) continue;                                   // not dyeable: never touched
      var flagged = total[it.variant_id] > Math.max(0, v.s);
      var cur = it.properties || {};
      var want = flagged ? c.dto : '';
      if ((cur[KEY] || '') === want) continue;
      var props = {};
      Object.keys(cur).forEach(function (k) { props[k] = cur[k]; });
      props[KEY] = want;
      return { line: i + 1, quantity: it.quantity, properties: props };
    }
    return null;
  }

  function redraw() {
    if (document.querySelector('.cb__form')) {            // cart page: reload it
      var n = 0;
      try { n = parseInt(sessionStorage.getItem('dtoSyncReloads') || '0', 10); } catch (e) {}
      if (n >= 3) return;
      try { sessionStorage.setItem('dtoSyncReloads', String(n + 1)); } catch (e) {}
      location.reload();
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    getJson('/?sections=cart-drawer').then(function (s) {
      var doc = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
      var src = doc.querySelector('#CartDrawer'), dst = document.getElementById('CartDrawer');
      if (!src || !dst) return;
      dst.innerHTML = src.innerHTML;
      var ov = dst.querySelector('#CartDrawer-Overlay');
      if (ov && drawer.close) ov.addEventListener('click', drawer.close.bind(drawer));
    }).catch(function () {});
  }

  function run() {
    if (running) return running;
    var deadline = Date.now() + CAP_MS;
    running = (function () {
      var c = cfg();
      if (!c) return Promise.resolve();
      var changed = false;
      function step(n) {
        if (n > 12 || Date.now() > deadline) return Promise.resolve();
        return getJson('/cart.js').then(function (cart) {
          var ch = nextChange(cart, c);
          if (!ch) return;
          changed = true;
          return fetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(ch)
          }).then(function () { return step(n + 1); });
        });
      }
      return step(0).then(function () {
        if (changed) redraw();
        else { try { sessionStorage.removeItem('dtoSyncReloads'); } catch (e) {} }   // in sync: allow future redraws
      }).catch(function () {});
    })().then(function () { running = null; }, function () { running = null; });
    return running;
  }

  // Checkout waits for an in-flight sync, but never more than CAP_MS and never on an error.
  document.addEventListener('click', function (e) {
    var t;
    try {
      t = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"]');
      if (!t || bypass || !cfg()) return;
    } catch (err) { return; }
    e.preventDefault(); e.stopPropagation();
    var done = false;
    function go() {
      if (done) return;
      done = true;
      bypass = true;
      try { t.click(); } catch (err) { location.href = '/checkout'; }
      setTimeout(function () { bypass = false; }, 1500);
    }
    setTimeout(go, CAP_MS);
    try { run().then(go, go); } catch (err) { go(); }
  }, true);

  var timer = null;
  function soon() { clearTimeout(timer); timer = setTimeout(run, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soon); else soon();
  /* Two triggers. A new data-dto-lines node means the drawer was rendered afresh (an add). Any other
     change inside the drawer means a quantity was changed there: Dawn's cart.js redraws only the item
     list and the footer, not the JSON node, so without this a line lowered back to the shelf stayed
     flagged until the next page load (the unexplained preview run of 2026-10-07). Our own redraw()
     lands here too; that run finds nothing to change and stops. */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.nodeType !== 1) t = t.parentElement;
      if (t && t.closest && t.closest('cart-drawer') && (muts[i].addedNodes.length || muts[i].removedNodes.length)) return soon();
      var a = muts[i].addedNodes;
      for (var j = 0; j < a.length; j++) {
        var n = a[j];
        if (n.nodeType === 1 && ((n.matches && n.matches('script[data-dto-lines]')) || (n.querySelector && n.querySelector('script[data-dto-lines]')))) return soon();
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
